module.exports = __webpack_public_path__ + "static/media/services1.5fdefa7f.png";